import { useMemo } from 'react'

import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { useProjectList } from './useProjectList'

export const useSelectedProject = () => {
  const { data: projects } = useProjectList()

  const { selectedProjectId } = useSelectedProjectStore()

  const selectedProject = useMemo(
    () => projects?.find(project => project.bc_guid === selectedProjectId),
    [projects, selectedProjectId]
  )

  return { selectedProject }
}
